import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { ThemeService } from './services/theme/theme.service';

@Component({
  imports: [RouterModule, RouterOutlet],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'Connect 24 - PANEL';

  layoutMode = 'overlay';

  darkMenu = false;

  isRTL = false;

  isDarkMode = false;

  body: HTMLBodyElement | null = document.querySelector('body');

  constructor(private themeService: ThemeService) {
    const storedDarkMode = localStorage.getItem('isDarkMode');
    if (storedDarkMode) {
      this.isDarkMode = storedDarkMode === 'true';
    }
    if (this.isDarkMode) {
      this.body?.classList.add('app-dark');
    }
  }

  toggleDarkMode(value: boolean) {
    this.body?.classList.toggle('app-dark');

    localStorage.setItem('isDarkMode', String(value));
    this.isDarkMode = value;
    this.themeService.toggleTheme();
  }
}
